import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const dataBR = (d) => {
  if (!d) return "-";
  const [y, m, day] = d.split("-");
  return `${day}/${m}/${y}`;
};

const grauLabel = { "1": "Grau I - Independente", "2": "Grau II - Dependência parcial", "3": "Grau III - Dependência total" };

export function gerarFichaPDF({ empresa, residente }) {
  const doc = new jsPDF();
  const azul = [37, 99, 235];

  // Cabeçalho
  doc.setFillColor(...azul);
  doc.rect(0, 0, 210, 26, "F");
  let tx = 14;
  if (empresa?.logo) {
    try { doc.addImage(empresa.logo, "PNG", 12, 4, 18, 18); tx = 34; } catch (e) { /* ignore */ }
  }
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.text(empresa?.nome || "Casa de Repouso São Jorge", tx, 12);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`CNPJ: ${empresa?.cnpj || "-"}`, tx, 18);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("FICHA DO RESIDENTE", 196, 14, { align: "right" });

  let y = 34;
  doc.setTextColor(30, 41, 59);

  const secao = (titulo) => {
    doc.setFillColor(241, 245, 249);
    doc.rect(14, y - 5, 182, 7, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(titulo, 16, y);
    y += 6;
  };

  const linhas = (pares) => {
    autoTable(doc, {
      startY: y,
      body: pares,
      theme: "plain",
      styles: { fontSize: 9, cellPadding: 1.5 },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 45, textColor: [100, 116, 139] },
        1: { cellWidth: 46 },
        2: { fontStyle: "bold", cellWidth: 45, textColor: [100, 116, 139] },
        3: { cellWidth: 46 },
      },
    });
    y = doc.lastAutoTable.finalY + 6;
  };

  secao("DADOS PESSOAIS");
  linhas([
    ["Nome", residente.nome || "-", "CPF", residente.cpf || "-"],
    ["RG", residente.rg || "-", "Órgão Emissor", residente.orgaoEmissor || "-"],
    ["CNS", residente.cns || "-", "Nacionalidade", residente.nacionalidade || "-"],
    ["Naturalidade", residente.naturalidade || "-", "Grau dependência", grauLabel[residente.grauDependencia] || "-"],
    ["Nome do Pai", residente.nomePai || "-", "Nome da Mãe", residente.nomeMae || "-"],
    ["Convênio", residente.convenio || "-", "Carteirinha", residente.carteirinhaConvenio || "-"],
  ]);

  secao("DADOS DE INTERNAÇÃO");
  linhas([
    ["Data de internação", dataBR(residente.dataInternacao), "Quarto", residente.quarto || "-"],
    ["Status", residente.status || "-", "", ""],
  ]);

  secao("RESUMO CLÍNICO");
  linhas([
    ["Tipo sanguíneo", residente.tipoSanguineo || "-", "Dieta", residente.dieta || "-"],
    ["Alergias", residente.alergias || "-", "Mobilidade", residente.mobilidade || "-"],
    ["Diagnósticos", residente.diagnosticos || "-", "Condições crônicas", residente.condicoesCronicas || "-"],
  ]);

  // Familiares
  const fams = residente.familiares || [];
  if (fams.length) {
    secao("FAMILIARES / CONTATOS");
    autoTable(doc, {
      startY: y,
      head: [["Nome", "Parentesco", "Telefone", "Resp. financ.", "Emergência"]],
      body: fams.map((f) => [
        f.nome || "-", f.parentesco || "-", f.telefone || "-",
        f.responsavelFinanceiro ? "Sim" : "Não", f.contatoEmergencia ? "Sim" : "Não",
      ]),
      theme: "striped",
      headStyles: { fillColor: azul, textColor: 255 },
      styles: { fontSize: 9, cellPadding: 2 },
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  doc.setFontSize(8);
  doc.setTextColor(120, 130, 145);
  doc.text(`Emitido em ${dataBR(new Date().toISOString().slice(0, 10))} · Documento sem valor financeiro.`, 14, 288);

  doc.save(`ficha-${(residente.nome || "residente").replace(/\s+/g, "_")}.pdf`);
}
